import React, { useEffect, useState } from "react";
import { Modal } from "bootstrap";
import BotaoSuporte from "../../components/BotaoSuporte.jsx";
import EditRastreamento from "../../rastreamento/editrastreamento.jsx";
import ConvocacaoTable from "../components/ConvocacaoTable";
import ExportButton from "../components/ExportButton";
import StatusCards from "../components/StatusCards";
import RastreamentoPainel from "../components/RastreamentoPainel";
import useConvocacaoRastreamento from "../hooks/useConvocacaoRastreamento";
import "../styles/convocacao.css";

const ConvocacaoRastreamento = () => {
    const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
    const {
        filtros,
        loading,
        painelRastreamento,
        statusCards,
        months,
        rows,
        total,
        page,
        pageSize,
        selectedIds,
        clearSelection,
        allPageSelected,
        updateFilter,
        toggleSelectRow,
        toggleSelectPage,
        changePage,
        changePageSize,
        convocarPaciente,
        convocarSelecionadas,
        exportarCsv,
    } = useConvocacaoRastreamento();

    useEffect(() => {
        if (!pacienteSelecionado) return;

        const modalElement = document.getElementById("edit-rastreamento");
        if (modalElement) new Modal(modalElement).show();
    }, [pacienteSelecionado]);

    const visualizarHistorico = (row) => {
        setPacienteSelecionado({
            id: row.pessoaId,
            nome: row.nome,
            cpf: row.cpf,
        });
    };

    const mesSelecionadoLabel = months.find(
        (item) => item.value === filtros.mes,
    )?.label;

    const subtituloTabela = filtros.ano && filtros.mes && mesSelecionadoLabel
        ? `Convocações pendentes referentes ao mês de ${mesSelecionadoLabel} de ${filtros.ano}`
        : filtros.ano
            ? `Convocações pendentes referentes a todos os meses de ${filtros.ano}`
            : "Convocações pendentes";


    return (
        <div className="page-wrapper">
            <BotaoSuporte />
            <div className="content">
                <div className="page-header">
                    <div className="page-title">
                        <h4>Convocação para Exames de Rastreamento</h4>
                        <h6>Planejamento anual e mensal da convocação de mulheres elegíveis.</h6>
                    </div>
                </div>

                <RastreamentoPainel
                    items={painelRastreamento}
                    selectedExam={filtros.exame}
                    selectedYear={filtros.ano}
                    selectedMonth={filtros.mes}
                    months={months}
                    onSelectYear={(exam, year) => updateFilter({ exame: exam, ano: year, mes: null })}
                    onSelectMonth={(exam, year, month) =>
                        updateFilter({ exame: exam, ano: year, mes: month })
                    }
                />

                <StatusCards items={statusCards} />

                <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-md-center mb-3">
                    <div className="text-muted small">
                        Selecionadas: {selectedIds.length}
                    </div>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={convocarSelecionadas}
                        disabled={selectedIds.length === 0 || loading}
                    >
                        <i className="feather-send me-2" />
                        Convocar selecionadas
                    </button>
                </div>

                <ConvocacaoTable
                    title={subtituloTabela}
                    headerAction={<ExportButton onClick={exportarCsv} />}
                    rows={rows}
                    loading={loading}
                    total={total}
                    selectedIds={selectedIds}
                    selectedCount={selectedIds.length}
                    onClearSelection={clearSelection}
                    allPageSelected={allPageSelected}
                    onTogglePage={toggleSelectPage}
                    onToggleRow={toggleSelectRow}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={changePage}
                    onPageSizeChange={changePageSize}
                    onConvocarRow={convocarPaciente}
                    onViewHistory={visualizarHistorico}
                />
            </div>
            <EditRastreamento
                pacienteSelecionado={pacienteSelecionado}
                onClose={() => setPacienteSelecionado(null)}
            />
        </div>
    );
};

export default ConvocacaoRastreamento;